
import React from 'react';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import SystemAnalytics from '@/components/admin/SystemAnalytics';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const AdminSystemAnalytics = () => {
  const { user } = useInternalAuth();
  const isMobile = useIsMobile();

  if (!user || user.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full px-4 md:px-6 ${
        isMobile 
          ? 'mt-16 mb-16 py-4' 
          : 'mt-24 mb-6 py-6 md:py-12'
      }`}>
        <div className="w-full max-w-7xl mx-auto space-y-6">
          <div className="flex items-center gap-4">
            <Button
              onClick={() => window.history.back()}
              variant="outline"
              className="border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
            <h1 className="text-2xl font-bold text-white">System Analytics</h1>
          </div>

          <SystemAnalytics />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default AdminSystemAnalytics;
